import { z } from 'zod';

import { toWithdrawalDTO, type WithdrawalDTO } from './get-withdrawals.schema';

// ── Response (API shape → transform to DTO) ─────────────
export type CancelWithdrawalDTO = WithdrawalDTO;

const CancelWithdrawalApiSchema = z
  .object({
    result: z.unknown(),
  })
  .transform(raw => toWithdrawalDTO(raw.result));

export function toCancelWithdrawalDTO(raw: unknown): CancelWithdrawalDTO {
  return CancelWithdrawalApiSchema.parse(raw);
}
